import React from 'react';

const LinkChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 15.5V7h-7v2h5v6h-5v2h7z"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M9 11h6v2H9z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 15.5V7h7v2H6v6h5v2H4v-1.5z"
        />
    </svg>
);

LinkChunkySvg.displayName = 'LinkChunkySvg';
export default LinkChunkySvg;
